import { Route, Routes } from 'react-router-dom-v5-compat';

import AlchemyPage from 'common/alchemyComponents/AlchemyPage';
import NotFound from 'common/components/ErrorPages/NotFound';

import { SettingsRewards } from './containers/SettingsRewards';
import { SettingsDashboard } from './containers/SettingsDashboard';

export const settingsBasePath = '/admin/company';

export default function Settings() {
  return (
    <AlchemyPage className="margin-top-large">
      <Routes>
        <Route path={settingsBasePath} element={<SettingsDashboard />} />
        <Route
          path={`${settingsBasePath}/positive_feedback_components`}
          element={<SettingsRewards />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AlchemyPage>
  );
}
